/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-04-07 15:43:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2023-09-19 20:01:29
 * @FilePath: \baishu_react_ui\src\components\BsyDept\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import React from 'react'
import './index.css'

import { BsyUtils } from '../../utils/Utils';
import BsyUser from '../BsyUser';




export default class BsySelectUser extends BsyUser {


  static defaultProps = {
    baseCls: "bsy-select-user",
    items: [],
    width: 350,
    height: 40,
    value: null,
    islinkQuery: !1,
    allowBlank: !0,
    noRepeat: !1,
    editable: !1,
    count: 100,
    limit: [],
    dynamicKey: window.FX.USER_ID.CurrentUser,
    is_dock_form: false,
    dynamicType: "select",
    onStopEdit: null,
    onBeforeEdit: null,
    type: 'user',


  }

  constructor(props) {
    super(props);

    this.element = React.createRef();

  }

  renderBody = () => {
    const { value, islinkQuery, ftoken, msg, appId, is_dock_form } = this.state;
    let item = null;
    let bg = {};
    if (value) {
      item = window.userSelectMap[value];
      if (item && (item.name || item.nickname))
        bg = BsyUtils.formatUserThumb(item.name || item.nickname);
    }
    if (BsyUtils.isObjectEmpty(item)) {
      item = { id: value }
    }
    return < >
      <ul className="select-list" >
        {
          value && item ? <li className="select-item" id={value}
          >
            {
              item && item.avatarurl ?
                <img className="user-center" alt="" src={item.avatarurl}></img> :
                BsyUtils.isObjectEmpty(bg) ? '' : <span className={'table-user-portrait-name color-' + bg.color} ><span>{bg.name[0]}</span></span>
            }
            <span>{BsyUtils._toDeptUser(item)}</span>
          </li> : <div className="select-empty"> </div>
        }
      </ul>
      {
        this.renderBtn('icon-widget-user', item)
      }


    </>

  }

  render() {
    const { cssName, css } = this.options
    if (!this.isEnabled()) {
      return this.renderDisablePane()
    }
    return (
      <div className={cssName} style={css}
        ref={this.element}
        onClick={this.onClick}
      >
        {
          this.renderBody()
        }
      </div>
    )
  }
}
